import {
  SharedUserNotificationSettingsFragment,
  UserSettingUpdateInput,
  useSharedUpdateUserSettingMutation,
} from 'shared/types/graphql';
import { GraphQLErrorPolicies } from 'shared/enums/GraphQLErrorPolicies';
import useClinicUser from 'shared/hooks/useClinicUser';

interface IUpdateUserSettingsHookInput {
  update(data: UserSettingUpdateInput): Promise<SharedUserNotificationSettingsFragment | undefined>;
  loading: boolean;
}

export function useUpdateUserSettings(): IUpdateUserSettingsHookInput {
  const [updateSettings, { loading }] = useSharedUpdateUserSettingMutation({
    errorPolicy: GraphQLErrorPolicies.All,
  });
  const { clinicUser } = useClinicUser();
  async function update(data: UserSettingUpdateInput): Promise<SharedUserNotificationSettingsFragment | undefined> {
    const res = await updateSettings({
      variables: {
        data,
        where: { id: clinicUser?.userSetting?.id },
      },
    });
    return res.data?.updateOneUserSetting;
  }
  return { update, loading };
}
